import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

const ProctorURequirements = observer(class ProctorURequirements extends React.Component {
  render() {
    const { translation } = this.props;

    return (
      <div className="text-block">
        <h5><strong>{translation.heading}</strong></h5>

        <ul>
          <li>
            <strong>{translation.chromebook_warning}</strong>
          </li>
          <li>
            <a
              href="https://guardian.meazurelearning.com"
              target="_blank"
            >
              {translation.extension}
            </a>
          </li>
          {translation.requirements.map(
            (requirement, i) => {
              return(
                <li key={i}>{requirement}</li>
              )
            }
          )}
        </ul>

        <p>
          <strong>
            {translation.record_reminder}
          </strong>
        </p>

        <p>
          <a
            href="https://test-it-out.proctoru.com/"
            target="_blank"
          >
            {translation.test}
          </a>
        </p>
      </div>
    )
  }
})

export default translate('ProctorURequirements')(ProctorURequirements);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ProctorURequirements.js